<template>
  <div>
    <v-progress-linear
      v-if="loading"
      :size="400"
      :width="10"
      color="#1E88E5"
      indeterminate
    ></v-progress-linear>
    <transition name="dashboard">
      <div v-if="!loading" class="main-div">
        <!-- <h1>Data Produk</h1> -->
        <div class="search">
          <v-btn
            class="mx-2"
            fab
            small
            @click="
              table.search = ''
              getAllProduct()
            "
            color="primary"
          >
            <v-icon>
              mdi-autorenew
            </v-icon>
          </v-btn>
          <v-text-field
            v-model="table.search"
            prepend-icon="mdi-magnify"
            class="input"
            label="Cari..."
            single-line
            hide-details
            @keyup="getAllProduct()"
          ></v-text-field>
        </div>

        <v-data-table
          :headers="table.headers"
          :items="products"
          :loading="loading"
          :search="table.search"
          :page.sync="table.pagination.page"
          :items-per-page="table.pagination.itemsPerPage"
          item-key="id"
          hide-default-footer
          class="elevation-0 "
          height="500px"
          dense
        >
          <template v-slot:[`item.isActive`]="{ item }">
            <v-icon v-if="item.isActive" color="green">
              mdi-check-outline
            </v-icon>
            <v-icon v-else color="red">
              mdi-close-outline
            </v-icon>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="isAdmin" icon v-bind="attrs" v-on="on">
                  <v-icon @click="onClickFooter(0, item.id)">
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn v-if="!isAdmin" icon v-bind="attrs" v-on="on">
                  <v-icon @click="onClickFooter(0, item.id)">
                    mdi-magnify
                  </v-icon>
                </v-btn>
              </template>
              <span v-if="isAdmin">Ubah data Produk</span>
              <span v-if="!isAdmin">Detail data Produk</span>
            </v-tooltip>
            <v-tooltip v-if="isAdmin && isTariffMenuEnabled" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon @click="onClickFooter(1, item.id)">
                    mdi-percent-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>Pengaturan tarif usia</span>
            </v-tooltip>
          </template>
        </v-data-table>

        <div class="footer">
          <div class="datatable-action">
            <v-pagination
              v-model="table.pagination.page"
              :length="pages"
              :total-visible="5"
              @input="getAllSubscription()"
            />
          </div>
          <v-spacer></v-spacer>
          <template v-if="isAdmin">
            <v-btn v-if="!isDemo" color="primary" fab dark @click="onClickFooter(0, '')">
              <v-icon dark>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>

          <template>
            <v-dialog v-model="dialog" max-width="1200">
              <product
                :id_product="selectedProduct"
                v-if="selectedForm == 0"
                @change-form="changeForm"
                @close-form="closeForm"
              />
              <product-tariff
                :id_product="selectedProduct"
                v-if="selectedForm == 1"
                @close-form="closeForm"
                @tariff-saved="getAllProduct()"
              />
            </v-dialog>
          </template>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import Constant from '@/const'
import Product from './components/Product'
import ProductTariff from './components/ProductTariff'

import ConstantMixin from '@/constantMixin'

const _ = require('lodash')
const axios = require('axios')

export default {
  components: {
    Product,
    ProductTariff
  },
  mixins: [ConstantMixin],
  data() {
    return {
      loading: true,
      isAdmin: false,
      // Pengaturan tarif usia adalah bagian dari fitur produk 303, jadi ikut saklar rilisnya dan
      // tetap tersembunyi di production selama fiturnya belum dirilis ke pengguna.
      isTariffMenuEnabled: Constant.productScope.enabled,
      products: [],
      productNewStatus: false,
      selectedProduct: '',
      dialog: '',
      selectedForm: null,
      pages: 0,
      table: {
        search: '',
        headers: [
          { text: 'Kode', value: 'code', width: '40px' },
          { text: 'Produk', value: 'name', width: '150px' },
          { text: 'Jenis', value: 'type', width: '100px' },
          { text: 'Pembiayaan', value: 'paymentMethod', width: '100px', sortable: false },
          { text: 'Iuran(Bulan)', value: 'due', width: '60px', sortable: false },
          { text: 'Aktif', value: 'isActive', width: '60px', sortable: false },
          { text: '', value: 'actions', width: '10px', sortable: false }
        ],
        pagination: {
          descending: false,
          page: 1,
          itemsPerPage: 10,
          sortBy: ''
        }
      }
    }
  },
  watch: {
    products: {
      handler() {
        this.$nextTick(() => {
          this.table.pagination.totalItems = this.products.length
          if (this.table.pagination.itemsPerPage == null || this.table.pagination.totalItems == null) {
            this.pages = 0
          } else {
            this.pages = Math.ceil(this.table.pagination.totalItems / this.table.pagination.itemsPerPage)
          }
        })
      },
      deep: true
    },
    dialog(newValue) {
      if (!newValue) {
        this.selectedForm = null
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (_.toLower(this.$store.getters.userLoggedIn.role) == 'administrator') this.isAdmin = true
      this.getAllProduct()
    })
  },
  methods: {
    getAllProduct(option) {
      this.loading = true
      let sortBy = _.get(option, 'sortDesc[0]', false) ? '-' : ''
      switch (_.get(option, 'sortby[0]', '')) {
        case 'code':
          sortBy = sortBy.concat('code')
          break
        case 'type':
          sortBy = sortBy.concat('type')
          break
        case 'name':
          sortBy = sortBy.concat('name')
          break
        default:
          sortBy = sortBy.concat('code')
          break
      }
      this.runApiCalls(() => {
        axios
          .get(Constant.apiUrl.concat(`/product${!this.isAdmin ? '/active' : ''}?sort=`, sortBy))
          .then(response => {
            if (response.status == 200) {
              const productDataGet = response.data.data
              this.products = productDataGet.map(product => {
                return {
                  id: _.get(product, '_id', '').toString(),
                  code: _.get(product, 'code', ''),
                  type: _.get(product, 'type', ''),
                  name: _.get(product, 'name', ''),
                  description: _.get(product, 'description', ''),
                  paymentMethod: _.get(product, 'payment_method', ''),
                  due: _.get(product, 'due_year', 0)
                    .toString()
                    .concat(' %'),
                  dueLength: _.get(product, 'due_min', '')
                    .toString()
                    .concat(' - ', _.get(product, 'due_max', '')),
                  isActive: _.get(product, 'isActive', false)
                }
              })
            }
            this.loading = false
          })
      })
    },
    deleteProduct(items) {
      Swal.fire({
        title: 'Anda Yakin ?',
        text: 'Data product akan dihapus',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then(result => {
        if (result.value) {
          if (items.status === true) {
            this.productNewStatus = false
          } else {
            this.productNewStatus = true
          }
          axios
            .post(Constant.apiUrl.concat('/product/data/status/', items.id), {
              status: this.productNewStatus
            })
            .then(response => {
              if (response.status === 200) {
                Swal.fire('Berhasil', 'Status Product Berhasil Diubah', 'success')
                this.getAllProduct()
              }
            })
            .catch(error => {
              if (error.response) {
                const message = error.response.data.pesan
                Swal.fire({
                  icon: 'error',
                  title: 'Terjadi Kesalahan',
                  text: message
                })
              } else if (error.request) {
                Swal.fire({
                  icon: 'error',
                  title: 'Terjadi Kesalahan',
                  text: 'Tidak dapat menyambung ke server'
                })
              } else {
                // eslint-disable-next-line
                console.log('Something happened in the middle of request')
              }
            })
        }
      })
    },
    onClickFooter(index, id_product) {
      this.selectedProduct = id_product
      switch (index) {
        default:
          this.changeForm(index)
          break
      }
      this.dialog = true
    },
    togglePropsExpanded(props) {
      this.$set(props, 'expanded', !props.expanded)
    },

    changeForm(item) {
      this.selectedForm = item
    },
    closeForm() {
      this.dialog = false
      this.getAllProduct()
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-enter {
  opacity: 0;
  transform: translateX(-100px);
}
.dashboard-leave-to {
  opacity: 0;
  transform: translateX(100px);
}
.dashboard-enter-active {
  transition: all 0.3s ease-in;
}

.main-div {
  margin: 10px auto;
  width: 90%;
}

h1 {
  font-size: 1.5em;
  text-align: left;
}

.search {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-end;
  right: 0;
}

.input {
  max-width: 30%;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}
</style>
